module.exports = __webpack_public_path__ + "img/functions_active.79ffaeea.svg";